/** Sort key from category label like "03 Aktivitäten" → 3. Unnumbered categories sort last. */
export function helpCategorySortKey(label: string): number {
  const m = /^(\d{1,2})\s/u.exec(label.trim());
  const n = m?.[1];
  return n !== undefined ? parseInt(n, 10) : 1000;
}

export function sortHelpCategories<T extends { label: string }>(categories: T[]): T[] {
  return [...categories].sort((a, b) => {
    const ka = helpCategorySortKey(a.label);
    const kb = helpCategorySortKey(b.label);
    if (ka !== kb) return ka - kb;
    return a.label.localeCompare(b.label, 'de-CH');
  });
}

/** Maps API min_role to short badge + tooltip (articles are filtered server-side by role rank). */
export function helpMinRolePresentation(minRole: string | undefined): { badge: string; description: string } {
  const r = (minRole || 'viewer').toLowerCase();
  switch (r) {
    case 'viewer':
    case 'supplier':
      return {
        badge: 'Alle Benutzer',
        description: 'Sichtbar für alle angemeldeten Benutzer (inkl. reinem Lesezugriff).',
      };
    case 'member':
      return {
        badge: 'Ab Member',
        description: 'Für Mitglieder mit Bearbeitungsrechten an Aktivitäten und Teamarbeit.',
      };
    case 'manager':
      return {
        badge: 'Ab Manager',
        description: 'Für Marketing-Manager mit Planungs- und Steuerungsaufgaben.',
      };
    case 'admin':
      return {
        badge: 'Administratoren',
        description: 'Nur für Administratoren: Einstellungen, Integrationen, sensible Themen.',
      };
    case 'super_admin':
      return {
        badge: 'Super-Admin',
        description: 'Höchste technische und organisatorische Rechte.',
      };
    default:
      return {
        badge: r,
        description: 'Mindestrolle für diesen Artikel.',
      };
  }
}
